























import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import ProjectSetteiForm from '@/components/project/organisms/ProjectSetteiForm.vue'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'

@Component({
  components: { TcwLayoutBasicTemplate, ProjectSetteiForm }
})
export default class ProjectSettei extends Mixins(BasePage) {
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected save(): void {
    this.form.startSaveProc()
  }

  protected back(): void {
    const form = this.form as any
    if (form.reset instanceof Function) {
      form.reset()
    }
    this.$router.back()
  }
}
